import Router, { Route, Switch } from '@alltrails/shared/components/ReactRouter';
import ApplicationLayout from 'components/ApplicationLayout/ApplicationLayout';
import CustomProvider from 'components/CustomProvider';
import PlusLandingPage from 'components/LandingPages/PlusLandingPage';
import Coupon from 'types/Coupon';
import CurrencyCode from 'types/CurrencyCode';
import Plan from 'types/Plan';
import { UserId } from '@alltrails/shared/types/User';
import PodcastLandingPage from 'components/LandingPages/PodcastLandingPage';
import PetSmartLandingPage from 'components/LandingPages/PetSmartLandingPage';
import TiktokLandingPage from 'components/LandingPages/TiktokLandingPage';
import CheckoutRoute from './CheckoutRoute';
import LoginRoute from './LoginRoute';
import RegisterRoute from './RegisterRoute';

type ProRouterProps = {
  annualPlan: Plan;
  coupon?: Coupon;
  currencyCode: CurrencyCode;
  planTypes: Plan[];
  userId?: UserId;
  whenExpired: string;
};

function ProRouter({ currencyCode, coupon, annualPlan, planTypes, userId, whenExpired }: ProRouterProps) {
  return (
    <Router fullpath={global.__AT_DATA__.pathname}>
      <Switch>
        <Route path="/:locale?/signup">
          <ApplicationLayout>
            <RegisterRoute coupon={coupon} />
          </ApplicationLayout>
        </Route>
        <Route path="/:locale?/login">
          <ApplicationLayout>
            <LoginRoute coupon={coupon} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/pro">
          <ApplicationLayout>
            <PlusLandingPage coupon={coupon} currencyCode={currencyCode} planTypes={planTypes} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/podcast">
          <ApplicationLayout>
            <PodcastLandingPage coupon={coupon} planTypes={planTypes} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/petsmart">
          <ApplicationLayout>
            <PetSmartLandingPage coupon={coupon} planTypes={planTypes} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/tiktok">
          <ApplicationLayout>
            <TiktokLandingPage coupon={coupon} planTypes={planTypes} userId={userId} currencyCode={currencyCode} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/meta">
          <ApplicationLayout>
            <PlusLandingPage coupon={coupon} planTypes={planTypes} userId={userId} currencyCode={currencyCode} />
          </ApplicationLayout>
        </Route>
        <Route path="/:locale?/pro/checkout">
          <CheckoutRoute
            annualPlan={annualPlan}
            coupon={coupon}
            currencyCode={currencyCode}
            plans={planTypes}
            userId={userId}
            whenExpired={whenExpired}
          />
        </Route>
        <Route exact path="/:locale?/plus">
          <ApplicationLayout>
            <PlusLandingPage coupon={coupon} currencyCode={currencyCode} planTypes={planTypes} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route path="/:locale?/plus/checkout">
          <CheckoutRoute
            annualPlan={annualPlan}
            coupon={coupon}
            currencyCode={currencyCode}
            plans={planTypes}
            userId={userId}
            whenExpired={whenExpired}
          />
        </Route>
        <Route path="/:locale?/plus/signup">
          <ApplicationLayout>
            <RegisterRoute />
          </ApplicationLayout>
        </Route>
      </Switch>
    </Router>
  );
}

type Props = {
  annualPlan: Plan;
  coupon?: Coupon;
  currencyCode: CurrencyCode;
  planTypes: Plan[];
  userId?: UserId;
  whenExpired: string;
};

export default function Pro({ planTypes, currencyCode, coupon, annualPlan, userId, whenExpired }: Props) {
  return (
    <CustomProvider>
      <ProRouter
        annualPlan={annualPlan}
        coupon={coupon}
        currencyCode={currencyCode}
        planTypes={planTypes}
        userId={userId}
        whenExpired={whenExpired}
      />
    </CustomProvider>
  );
}
